import * as React from 'react';
// import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { toAbsoluteUrl } from "../toAbsoluteUrl";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

export default function BreadcrumbsComponent(props) {
    let breadcrumbs = [];
    props.pages.forEach((rowData, index) => {
        <Typography key="3" color="text.primary">
      Breadcrumb
    </Typography>
   breadcrumbs.push((index != props.pages.length - 1 )?<Link underline="hover" key="1" color="inherit" href={`/${rowData.link}`} >
     {rowData.name}
   </Link>:<Typography key="3" color="text.primary">
   {rowData.name}
    </Typography>)
   })
    
  props.pages.forEach(element => {
    
  });


  return (
    <div className='Breadcrumbs'>

    <Stack spacing={2}>
      <Breadcrumbs separator={<img src={toAbsoluteUrl("/media/images/Chevron.svg")} />}aria-label="breadcrumb">
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
    </div>
  );
}
// function handleClick(event) {
//   event.preventDefault();
//   console.info('You clicked a breadcrumb.');
// }

// export default function BreadcrumbsComponent(props) {
// // function displayBreadcrumbs() {
// //     let Breadcrumb =''
// //     Breadcrumb = props.pages.map((rowData, index) => {
// //         return (
// //             <span onClick={() =>navigate(`/`)}> {rowData}</span>
// //         );
// //       });
    
// // }

//   return (
//     <div className='Breadcrumbs'>
//         {/* <a onClick={() =>navigate(`/`)> Home</a> */}
//         {/* {displayBreadcrumbs} */}
//     </div>
//   );
// }
